<template>
    <div class="shops" ref="shops" v-infinite-scroll="loadMore" infinite-scroll-disabled="canNotLoadMore" infinite-scroll-distance="10" infinite-scroll-immediate-check="false" style="-webkit-user-drag: none;">
        <p-header :title="title" v-if="isFavorite" ref="pHeader"/>
        <p-header :title="title" v-else ref="pHeader" :left-icon="require('@/assets/img/cart.svg')" @onLeftBtn="onLeftBtn" :count="cartCount"/>
        <div class="nav" ref="nav" v-show="! isFavorite" :style="NavStyle">
            <div class="outside" :class="{active: NavIsActive}" ref="outside">
                <div class="search-and-address">
                    <search-address
                            class="search"
                            ref="address"
                            :isFocus="false"
                            :value="fullAddress"
                            :gray-style="true"
                            placeholder="請輸入送達地址"
                            @onSelected="selectedPlace"
                            @onFocus="searching = true"
                            @onBlur="searching = false"/>
                    <router-link v-show="!searching" class="search-btn" tag="div" :to="{name: 'search', query: {location: base64Location}}">
                        <img src="@/assets/img/search.svg">想找？
                    </router-link>
                </div>
                <div v-if="!isEmpty" v-show="! searching">
                    <div v-show="!only.length">
                        <div class="scroll-div">
                            <div class="scroll" ref="scroll">
                                <div class="scroll-content" v-show="!isShowCategories">
                                    <div class="scroll-item"
                                         v-for="category in categories"
                                         :key="category.id"
                                         @click="selectCategory(category)"
                                         :ref="'item-' + category.id"
                                         :class="{active: category.id === selectedCategory.id}">
                                        <div class="category">
                                            {{ category.name }}
                                        </div>
                                    </div>
                                </div>
                                <div class="scroll-title" v-show="isShowCategories">
                                    所有類別
                                </div>
                            </div>
                            <div class="scroll-btn" @click="onCategories">
                                <img :class="{up: isShowCategories}" src="@/assets/img/down-green.svg">
                            </div>
                        </div>
                        <div class="scroll-all" v-show="isShowCategories">
                            <div class="scroll-item"
                                 v-for="category in categories"
                                 :key="category.id"
                                 @click="selectCategory(category, true)"
                                 :class="{active: category.id === selectedCategory.id}">
                                <div class="category">
                                    {{ category.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="list container" v-if="!isEmpty" :class="{opacity: isShowCategories }" v-show="! searching">
            <div class="content">
                <shop-item v-for="shop in shops" :key="shop.id" :shop="shop" :location="location"/>
            </div>
        </div>
        <div class="empty" v-if="isEmpty && ! searching">
            <div class="img">
                <img src="@/assets/img/gps.svg">
            </div>
            <div class="title">
                無法找到您的所在位置
            </div>
            <div class="content">
                若無送達地址將無法提供店家列表給您
                <br/>
                請提供 GPS 系統自動定位或手動輸入地址
            </div>
        </div>
        <div class="empty" v-else-if="isFavorite && ! this.shops.length">
            <div class="img">
                <img src="@/assets/img/heartbreak.svg">
            </div>
            <div class="title">
                目前無收藏
            </div>
            <div class="content">
                快去逛逛都有哪些店家吧
                <br><br>
                <router-link :to="{name: 'ShopList', query: {}}" tag="div" class="button">
                    前往店家
                </router-link>
            </div>
        </div>
        <gps-modal ref="GPSModal" @onConfirm="GPSConfirm"/>
        <div class="shadow" id="categories-shadow" v-show="isShowCategories" @click.stop="onCategories"/>
    </div>
</template>

<script>
    import SearchAddress from '../components/task/SearchAddress';
    import Header from '../components/Header';
    import * as apis from '../../apis';
    import ScrollBooster from 'scrollbooster';
    import { mapGetters, mapActions } from 'vuex';
    import * as R from 'ramda';
    import ShopItem from './Item';
    import GPSModal from '../components/modal/GPSModal';

    export default {
        name: 'ShopList',
        components: {
            'search-address': SearchAddress,
            'p-header': Header,
            'shop-item': ShopItem,
            'gps-modal': GPSModal,
        },
        data() {
            return {
                title: '店家列表',
                searching: false,
                location: {
                    alias: '',
                    city: '',
                    district: '',
                    road: '',
                    name: '',
                    phone: '',
                    additional: '',
                    latitude: null,
                    longitude: null,
                },
                categories: [],
                shops: [],
                sort: 'distance',
                selectedCategory: null,
                sb: null,
                NavHeight: 0,
                NavIsActive: false,
                loading: false,
                page: {
                    total: 0,
                    current_page: 0,
                    last_page: 0,
                },
                isShowCategories: false,
                only: [],
                isFavorite: false,
                isSelf: false,
                isEscrow: false,
                isFilterCategories: false,
            }
        },
        computed: {
            base64Location() {
                return encodeURIComponent(JSON.stringify(this.location));
            },
            isEmpty() {
                return !this.location.latitude
            },
            fullAddress() {
                return (this.location.city + this.location.district + this.location.road) || '';
            },
            canNotLoadMore() {
                return !(this.page.total && this.page.current_page < this.page.last_page && !this.loading);
            },
            NavStyle() {
                if (! this.NavHeight) {
                    return {};
                }

                return {
                    height: this.NavHeight + 'px',
                }
            },
            ...mapGetters(['address', 'user', 'isLogin', 'cartCount'])
        },
        methods: {
            GPSConfirm(result) {
                switch (result.type) {
                    case 'empty':
                        this.$refs.address.onFocus();
                        break;
                    case 'GPS':
                        this.selectedPlace(result.address);
                        break;
                    case 'edit':
                        this.selectedPlace(result.address);
                        setTimeout(() => {
                            this.$refs.address.onFocus();
                        }, 50);
                        break;
                }
            },
            onCategories() {
                this.isShowCategories = ! this.isShowCategories;
                if (this.isShowCategories) {
                    this.lockScroll();
                    this.$nextTick(this.setShadowTop());
                } else {
                    this.unlockScroll();
                }
            },
            setShadowTop() {
                document.getElementById('categories-shadow').style.top = this.$refs.outside.getBoundingClientRect().bottom - this.$refs.pHeader.$el.getBoundingClientRect().top + 'px';
            },
            lockScroll() {
                document.getElementById('paopaotui-page').style.overflow = 'hidden';
            },
            unlockScroll() {
                document.getElementById('paopaotui-page').style.overflow = '';
            },
            initScroll() {
                setTimeout(() => {
                    let viewport = document.querySelector('.scroll')
                    let content = viewport.querySelector('.scroll-content')
                    this.sb = new ScrollBooster({
                        viewport,
                        content,
                        mode: 'x',
                        onUpdate: (data)=> {
                            content.style.transform = `translateX(${-data.position.x}px)`
                        }
                    });
                }, 100);
            },
            selectedPlace(place) {
                this.location.city = place.city;
                this.location.district = place.district;
                this.location.road = place.road;
                this.location.latitude = place.latitude;
                this.location.longitude = place.longitude;
                this.location.name = place.name || this.user.name;
                this.location.phone = place.phone || this.user.phone;
                this.location.additional = place.additional || '';
                this.location.alias = place.alias || '';
                this.getNearbyShops();
            },
            selectCategory(category, move = false) {
                this.selectedCategory = category;
                this.getNearbyShops();
                this.unlockScroll();
                this.isShowCategories = false;
                this.$nextTick(() => {
                    let categoryOffsetLeft = this.$refs[`item-${category.id}`][0].offsetLeft;
                    let scrollWidth = this.$refs.scroll.getBoundingClientRect().width;
                    let scrollLeft = this.$refs.scroll.scrollLeft;

                    if (move && categoryOffsetLeft > (scrollWidth + scrollLeft)) {
                        this.sb.setPosition({
                            x: categoryOffsetLeft,
                            y: 0
                        });
                    }

                })
            },
            setCategories(categories) {
                this.categories = categories;

                if (this.selectedCategory) {
                    let index = this.categories.findIndex(c => c.id == this.selectedCategory.id);
                    if (index < 0) {
                        this.selectedCategory = null;
                    }
                }

                if (! this.selectedCategory && this.categories.length) {
                    this.selectedCategory = this.categories[0];
                }

                if (this.sb) {
                    this.$nextTick(() => {
                        this.sb.updateMetrics();
                    });
                }
            },
            getNearbyShops() {
                if (this.isFavorite) {
                    this.getFavoriteShops();
                    return;
                }

                if (! this.sort || ! this.selectedCategory) {
                    return;
                }

                apis.getNearbyShops({
                    latitude: this.location.latitude,
                    longitude: this.location.longitude,
                    sort: this.sort,
                    category_id: this.selectedCategory.id,
                    self: (this.isSelf || this.isFilterCategories) ? 1 : 0,
                    escrow: (this.isEscrow || this.isFilterCategories) ? 1 : 0,
                }).then(res => {
                    this.shops = res.data.data;
                    this.page = res.data.meta;
                });
            },
            getFavoriteShops() {
                apis.getFavorites().then(res => {
                    this.shops = res.data.data;
                    this.page = res.data.meta;
                });
            },
            onScroll() {
                let bottom = this.$refs.pHeader.$el.getBoundingClientRect().bottom;
                if (bottom < 0) {
                    this.NavHeight = this.$refs.nav.getBoundingClientRect().height;
                    this.NavIsActive = true;
                } else {
                    this.NavHeight = 0;
                    this.NavIsActive = false;
                }
            },
            loadMore() {
                this.loading = true;

                if (this.isFavorite) {
                    apis.getFavorites({
                        page: this.page.current_page + 1,
                    }).then(res => {
                        this.shops = R.concat(this.shops, res.data.data);
                        this.page = res.data.meta;
                        this.loading = false;
                    });

                    return;
                }

                apis.getNearbyShops({
                    latitude: this.location.latitude,
                    longitude: this.location.longitude,
                    sort: this.sort,
                    category_id: this.selectedCategory.id,
                    page: this.page.current_page + 1,
                    self: (this.isSelf || this.isFilterCategories) ? 1 : 0,
                    escrow: (this.isEscrow || this.isFilterCategories) ? 1 : 0,
                }).then(res => {
                    this.shops = R.concat(this.shops, res.data.data);
                    this.page = res.data.meta;
                    this.loading = false;
                });
            },
            distanceGPS() {
                if (! this.address) {
                    this.$refs.GPSModal.show('empty');
                } else {
                    this.$refs.GPSModal.show('address', 0, 0, this.address);
                }

                return 0;
            },
            onLeftBtn() {
                this.$router.push({
                    name: 'buy',
                });
            },
            reloadShopList() {
                this.isFavorite = this.$route.query.favorite || false;
                this.only = this.$route.query.onlyCategory ? [this.$route.query.onlyCategory] : [];
                let ADIds = this.$route.query.ADIds;

                let filterCategories = ADIds || this.only;
                filterCategories = Array.isArray(filterCategories) ? filterCategories : [filterCategories];

                if (filterCategories.length) {
                    this.isFilterCategories = true;
                } else {
                    this.isFilterCategories = false;
                }

                let payload = {
                    ids: filterCategories,
                    self: (this.isSelf || this.isFilterCategories) ? 1 : 0,
                    escrow: (this.isEscrow || this.isFilterCategories) ? 1 : 0,
                };
                apis.getCategories(payload).then(res => {
                    this.setCategories(res.data);
                    this.getNearbyShops();
                    this.onScroll();
                });

                this.title = this.$route.query.title || '店家列表';
            },
            ...mapActions(['getAddresses', 'initCart']),
        },
        beforeRouteUpdate(to, from, next) {
            next();
            if (to.name === from.name) {
                this.reloadShopList();
            }
        },
        mounted() {
            if (this.address) {
                this.selectedPlace(this.address);
            } else if (this.isLogin) {
                this.getAddresses().then(() => {
                    this.distanceGPS();

                    if (! this.address) {
                        return;
                    }

                    this.selectedPlace(this.address);
                })
            } else {
                this.$nextTick(() => this.distanceGPS());
            }
            this.initCart('buy');
            this.initScroll();
            window.addEventListener('scroll', this.onScroll);
        },
        updated() {
            if (this.sb) {
                this.$nextTick(() => {
                    this.sb.updateMetrics();
                })
            }
            if (this.isShowCategories) {
                this.lockScroll();
                this.$nextTick(this.setShadowTop());
            }
        },
        destroyed() {
            this.sb.destroy();
            window.removeEventListener('scroll', this.onScroll);
        },
        activated() {
            this.isSelf = this.$route.query.self;
            this.isEscrow = this.$route.query.escrow;
            this.reloadShopList();
        },
        watch: {
            "address.id": {
                handler() {
                    if (this.address) {
                        this.selectedPlace(this.address);
                    }
                },
            }
        }
    };
</script>

<style lang="scss" scoped>
    .shops {
        flex: 1;
        position: relative;

        .shadow {
            position: absolute;
            left: 0;
            top: 0;
            background-color: rgba(0,0,0,.40);
            width: 100%;
            height: 100%;
            z-index: 999;
        }

        .highlight {
            z-index: 9999;
        }
    }

    .search {
        margin: 0 15px 10px 15px;
    }

    .container {
        text-align: left;
        margin: 0 15px;

        &.opacity {
            filter: opacity(0.3);
        }

        .title {
            font-weight: 500;
            font-size: 20px;

            .subtitle {
                font-size: 14px;
                font-weight: normal;
                color: #9B9B9B;
                margin: 0 5px;
            }
        }

        .content {
            margin: 5px 0;
        }
    }

    .scroll-div {
        display: flex;
        align-items: center;
        position: relative;
    }

    .scroll-all {
        display: flex;
        flex-wrap: wrap;
        border-top: solid 1px #F5F5F5;
        padding: 10px 0;
    }

    .scroll {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;
        min-height: 57px;
        width: calc(100% - 30px);
        display: flex;
        align-items: center;
    }

    .scroll-title {
        text-align: left;
        color: #4A4A4A;
        font-family: "PingFang TC";
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        margin-left: 15px;
    }

    .scroll-content {
        display: flex;
        flex-wrap: nowrap;
        width: fit-content;
    }

    .scroll::-webkit-scrollbar {
        display: none;
    }

    .scroll-item {
        padding: 10px;
        background-color: #FFFFFF;
        border-radius: 5px;
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
        margin: 7px;
        white-space: nowrap;

        &:first-child {
            margin-left: 15px;
        }

        &:last-child {
            margin-right: 15px;
        }

        &.active {
            border-bottom: 3px solid #339933;
        }
    }

    .scroll-btn {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        background-image: linear-gradient(90deg, rgba(255, 255, 255, 0), #fff 30%, #fff);

        img {
            width: 20px;
            height: 20px;

            &.up {
                transform: rotate(180deg);
            }
        }
    }

    .nav {
        .outside {
            max-width: 500px;
            background-color: white;
            top: 0;
            left: 0;
            max-height: var(--app-height);
            overflow-x: auto;

            &.active {
                position: fixed;
                z-index: 10;
            }
        }
    }

    .sort {
        text-align: left;
        margin: 5px 15px;
        display: flex;

        .option {
            margin-left: 10px;
        }

        .active {
            color: #339933;
        }
    }

    .empty {
        margin-top: 60px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .title {
            font-size: 20px;
            font-family: "PingFang TC";
            color: #4A4A4A;
            margin-top: 20px;
        }

        .content {
            font-family: "PingFang TC";
            font-size: 12px;
            color: #4A4A4A;
            margin-top: 5px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .button {
                height: 25px;
                width: 68px;
                border-radius: 13px;
                background-color: #339933;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                letter-spacing: 0;
                line-height: 17px;
                color: #FFFFFF;
            }
        }
    }

    .search-and-address {
        display: flex;
        user-select: none;

        .search {
            flex: 1;
        }

        .search-btn {
            cursor: pointer;
            margin-right: 15px;
            height: 40px;
            width: 84px;
            border-radius: 20px 5px 5px 20px;
            background-color: #339933;
            box-shadow: 0 1px 5px 0 rgba(51,153,51,0.35);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #FFFFFF;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 20px;
        }
    }

    @media screen and (max-width: 767px) {
        .outside {
            width: 100%;
        }
    }

    @media screen and (min-width: 768px) and (max-width: 991px) {
        .outside {
            width: 500px;
        }
    }

    @media screen and (min-width: 992px) and (max-width: 1199px) {
        .outside {
            width: 500px;
        }
    }

    @media screen and (min-width: 1200px) {
        .outside {
            width: 500px;
        }
    }
</style>
